import gql from 'graphql-tag'

export const GET_ME = gql`
  query  {
    me {
      id
      email
      stocks {
        id
        name
      }
      role {
        id
        accessSetting
        settingOrderPage
        settingStock
        settingManageUser
        settingRole
        settingReseller
        settingUnit
        settingManageMessage
        settingI18n
        settingPacking
        settingProduct
        settingVat
        settingPromoCode
        settingCrm
        settingShippingCalculator
        settingCreditCard
        settingCustomPrint
        settingBankAccount
        changePassword
      }
    }
  }
`

export default {
  GET_ME
}
